window.IS_TOUCH_DEVICE = false

/**
 * Check if user's device supports touch
 * 
 * @return {Boolean}
 */
window.IS_TOUCH_DEVICE = ('ontouchstart' in window) || window.DocumentTouch && document instanceof DocumentTouch
